import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IConfiguration } from './types';
import { RootState } from 'store/index';

import { Integrations } from 'constants/integrations';
import {
  SESSION_STORAGE_PSA,
  SESSION_STORAGE_PSA_ID,
  SESSION_STORAGE_SCREEN,
  SESSION_STORAGE_TICKET_ID,
} from 'constants/sessionStorage';

const initialState: Partial<IConfiguration> = {
  openBanner: false,
};

const configurationSlice = createSlice({
  name: 'configuration',
  reducers: {
    setConfigurationData: (state, action: PayloadAction<IConfiguration>) => {
      sessionStorage.setItem(SESSION_STORAGE_PSA_ID, String(action.payload.psaId));
      sessionStorage.setItem(SESSION_STORAGE_TICKET_ID, String(action.payload.ticketId));

      if (action.payload.screen) {
        sessionStorage.setItem(SESSION_STORAGE_SCREEN, action.payload.screen);
      }
      return { ...state, ...action.payload };
    },
    setConfigPsa: (state, action: PayloadAction<Integrations>) => {
      state.psa = action.payload;
      sessionStorage.setItem(SESSION_STORAGE_PSA, String(action.payload));
    },
    setBannerState: (state, action) => {
      state.openBanner = action.payload;
    },
  },
  initialState,
});

export default configurationSlice.reducer;
export const { setConfigurationData, setConfigPsa, setBannerState } = configurationSlice.actions;
export const ConfigurationSelector = (state: RootState): Partial<IConfiguration> =>
  state.configuration;
